import React from 'react';
import { Alert, Typography } from '@one-thd/sui-atomic-components';

const OutOfStockAlert = () => (
  <Alert status="warning" size="large">
    <div>
      <Typography variant="body-sm" weight="bold">This cabinet is out of stock.</Typography>
      <Typography variant="body-sm">
        You can still place this cabinet in your layout, but it is not available for purchase at this time.
      </Typography>
    </div>
  </Alert>
);

OutOfStockAlert.displayName = 'OutOfStockAlert';

export { OutOfStockAlert };
